<template>
    <div>
        <table class="table table-hover" v-bind:id="id"  width="100%">
          <thead> </thead>
          <tbody> </tbody>
        </table>
    </div>
  </template>
  <script>
    export default {
      name:"TableLicenciaAlcoholes",
      props: {id:'',data_:[],lengthMenu:[]},
      mounted () {
        //$('#'+this.id).DataTable();
        //TableManaged2.init2();
        this.createTable();
        window.licAlcoholes = this;
      },
      methods:{
        accionDetalle(dato){
          this.$emit('detalle', dato);
        },
        accionEliminar(dato){
          this.$emit('eliminar', dato);
        },
        exportarExcel(){
          // El estado de "exportando" se avisa al padre por evento (no via
          // $refs en su template) porque $refs no es reactivo: el padre
          // nunca detectaria el cambio de flag si se leyera directamente
          // de $refs.tablaAlcoholes.exportandoExcel.
          this.$emit('export-start', 'excel');
          // setTimeout deja que Vue pinte el spinner antes de que la
          // generacion del xlsx (sincrona, bloquea el hilo principal con
          // datasets grandes) arranque.
          setTimeout(() => {
            $('#'+this.id).DataTable().button(0).trigger();
            this.$emit('export-end', 'excel');
          }, 50);
        },
        exportarCsv(){
          this.$emit('export-start', 'csv');
          setTimeout(() => {
            $('#'+this.id).DataTable().button(1).trigger();
            this.$emit('export-end', 'csv');
          }, 50);
        },
        createTable(){
          // Columnas 0-21 replican el orden/campos del export de servidor
          // (RefrendoAlcoholesExport) para que "Excel"/"CSV" generados aqui
          // (client-side, via Buttons) traigan exactamente lo mismo que antes
          // se generaba en el servidor. Las marcadas visible:false no se
          // muestran en pantalla pero si se incluyen en la exportacion.
          $('#sample_2').DataTable( {
            "data": this.data_,
            // Sin "B" en el dom: los botones de Buttons no se dibujan aqui,
            // se disparan desde botones propios (mismo estilo del portlet)
            // via exportarExcel()/exportarCsv().
            "dom": "frtip",
            "buttons": [
              { "extend": "excelHtml5", "title": "PADRON LICENCIA ALCOHOLES", "exportOptions": { "columns": ":not(.no-export)" } },
              { "extend": "csvHtml5", "title": "PADRON LICENCIA ALCOHOLES", "exportOptions": { "columns": ":not(.no-export)" } }
            ],
            "columns": [
              {"data": "folio_id","title":"Folio ID"},
              {"data": "licencia","title":"Licencia"},
              {"data":"rfc","title":"RFC"},
              {"data":"titular","title":"Titular","visible":false},
              {"data": "nombre_comercial","title":"Nombre Comercial"},
              {"data":"domicilio","title":"Domicilio","visible":false},
              {"data":"municipio","title":"Municipio"},
              {"data":"giro_ley_de_hacienda_del_estado","title":"Giro Ley de Hacienda del Estado","visible":false},
              {"data":"giro_anuencia_municipal","title":"Giro Anuencia Municipal","visible":false},
              {"data":"inciso","title":"Inciso","visible":false},
              {"data":"metros_cuadrados_capacidad","title":"Metros Cuadrados / Capacidad","visible":false},
              {"data":"ano_a_cobrar","title":"Año"},
              {"data":"derecho_en_cuotas","title":"Derecho en Cuotas","visible":false},
              {"data":"fecha_de_vencimiento","title":"Fecha de vencimiento"},
              {"data":"derecho","title":"Derecho"},
              {"data":"actualizacion","title":"Actualización"},
              {"data":"recargos","title":"Recargos"},
              {"data":"sancion","title":"Sanción"},
              {"data":"total","title":"Total"},
              {"data":"estatus","title":"Estatus",
                "render": this.spanEstatus
              },
              {"data":"tipo_de_pago","title":"Tipo de Pago","visible":false},
              {"data":"folio_de_pago","title":"Folio de Pago","visible":false},
              {"render": this.btnDetalle, "className":"no-export" },
              {"render": this.btnEliminar, "className":"no-export" },
            ]
          });
        },
        btnDetalle( data, type, row, meta){
          return "<a class='btn btn-icon-only btn-circle green' data-toggle='modal' href='#portlet-edit' title='Detalle Registro'  onclick='accionDetalle("+JSON.stringify(row)+")'><i class='fa fa-list'></i></a>";
        },
        btnEliminar( data, type, row, meta){
          let btn="";
          if(row.estatus=="VIGENTE"){
            btn="<a class='btn btn-icon-only btn-circle red' data-toggle='modal' href='#portlet-del' title='Eliminar Registro'  onclick='accionEliminar("+JSON.stringify(row)+")'><i class='fa fa-trash-o'></i></a>";
          }
          
          return btn;
        },
        spanEstatus( data, type, row, meta){
          let status=row.estatus==='VIGENTE' ? 'btn-success' : row.estatus==='REFERENCIA ACTIVA' ? 'btn-warning' : row.estatus==='PAGADO' ? 'label-default' : 'label-danger'
          return '<span class="label  btn-circle '+status+'" class="">'+row.estatus+' </span>';
        }
      }   
    }
  </script>